import { AutomaticPaymentRemindersType } from '../../../../../enums/automaticPaymentRemindersType'

interface AutomaticPaymentRemindersRowTKeys {
  description?: string
  title: string
}

export const automaticPaymentRemindersRowTKeysByType: Record<
  AutomaticPaymentRemindersType,
  AutomaticPaymentRemindersRowTKeys
> = {
  [AutomaticPaymentRemindersType.AfterDueDate]: {
    description: 'settings.organization.external_invoice.automatic_payment_reminders.after_due_date.description',
    title: 'settings.organization.external_invoice.automatic_payment_reminders.after_due_date.title',
  },
  [AutomaticPaymentRemindersType.BeforeDueDate]: {
    description: 'settings.organization.external_invoice.automatic_payment_reminders.before_due_date.description',
    title: 'settings.organization.external_invoice.automatic_payment_reminders.before_due_date.title',
  },
  [AutomaticPaymentRemindersType.OnDueDate]: {
    title: 'settings.organization.external_invoice.automatic_payment_reminders.on_due_date.title',
  },
}
